/**
 * cityDataUKNeighborhoods.js
 * Bloques SEO expandibles para barrios londinenses (region UK).
 * Se fusionan en cityInfo de cityData.js.
 */

function uk(short, desc, priceRange, avgPrice, zones, seoContent, highlights, faqs, students = false) {
  return { desc, short, students, priceRange, avgPrice, zones, universities: [], seoContent, highlights, faqs };
}

export const cityInfoUKNeighborhoods = {
  'Canary Wharf': uk(
    "London's financial district",
    'Canary Wharf',
    '£1,400 - £1,800',
    '£1,550/mo',
    ['Canary Wharf', 'Isle of Dogs', 'South Quay', 'Crossharbour', 'Heron Quays'],
    `Canary Wharf coliving puts you steps from Europe's largest financial hub — DLR and Jubilee line connections to the City and West End. Private furnished rooms from £1,400/mo, no agency fees. Modern riverside living with premium amenities, ideal for finance, consulting and tech professionals working in Docklands.`,
    ['Jubilee line to London Bridge in 5 min', 'DLR across East London', 'Modern riverside district', 'No agency fees — all-inclusive pricing'],
    [
      { q: 'How much is coliving in Canary Wharf?', a: 'From £1,400/mo to £1,800/mo all-inclusive, no agency fees. Premium for living in London\'s main financial district with excellent transport.' },
      { q: 'Is Canary Wharf good for finance workers?', a: 'Yes — it\'s the most convenient location if you work in banking, insurance or consulting in Docklands. Walk-to-work or 5-minute DLR commute.' },
    ]
  ),
  'Hounslow': uk(
    'well-connected West London',
    'Hounslow',
    '£1,100 - £1,400',
    '£1,250/mo',
    ['Hounslow Central', 'Hounslow East', 'Hounslow West', 'Feltham border', 'Osterley'],
    `Hounslow coliving offers excellent value in West London with Piccadilly line access to Heathrow (10 min) and Central London (30 min). Private furnished rooms from £1,100/mo, no agency fees. Popular with international professionals, airport workers and those who want more space for their budget.`,
    ['Piccadilly line to Heathrow in 10 min', 'From £1,100/mo — strong West London value', 'International community', 'Good for frequent travellers'],
    [
      { q: 'How much is coliving in Hounslow?', a: 'From £1,100/mo to £1,400/mo all-inclusive, no agency fees. Among the most affordable options with fast Piccadilly line access.' },
      { q: 'Is Hounslow well connected?', a: 'Piccadilly line to Green Park in 30 min, Heathrow in 10 min. Good bus links across West London.' },
    ]
  ),
  'West Hampstead': uk(
    'leafy North West London village',
    'West Hampstead',
    '£1,500 - £1,700',
    '£1,600/mo',
    ['West End Lane', 'Kilburn border', 'Swiss Cottage side', 'Fortune Green', 'South Hampstead'],
    `West Hampstead coliving combines village atmosphere with excellent transport — Jubilee, Overground and Thameslink at one interchange. Private furnished rooms from £1,500/mo, no agency fees. Boutique shops, cafés and Hampstead Heath nearby.`,
    ['Jubilee + Overground + Thameslink hub', 'Village feel with central access', 'Near Hampstead Heath', 'Popular with media and creative professionals'],
    [
      { q: 'How much is coliving in West Hampstead?', a: 'From £1,500/mo to £1,700/mo all-inclusive, no agency fees.' },
      { q: 'Why choose West Hampstead?', a: 'Excellent triple-rail connectivity, leafy neighbourhood and quick access to the West End and City via Jubilee line.' },
    ]
  ),
  'Notting Hill': uk(
    'iconic West London neighbourhood',
    'Notting Hill',
    '£1,600 - £2,000',
    '£1,800/mo',
    ['Portobello Road', 'Ladbroke Grove', 'Holland Park', 'Westbourne Grove', 'Notting Hill Gate'],
    `Notting Hill coliving places you in one of London's most iconic neighbourhoods — Portobello Market, colourful terraces and Holland Park on the doorstep. Private furnished rooms from £1,600/mo, no agency fees. Central line and Circle line connections to the West End and City.`,
    ['Portobello Road Market on your doorstep', 'Holland Park and Westbourne Grove', 'Central & Circle lines', 'Iconic West London lifestyle'],
    [
      { q: 'How much is coliving in Notting Hill?', a: 'From £1,600/mo to £2,000/mo all-inclusive, no agency fees. Premium West London location.' },
      { q: 'Is Notting Hill central?', a: 'Notting Hill Gate (Central, Circle, District) connects to Oxford Circus in 10 min and the City in 20 min.' },
    ]
  ),
  'Marylebone': uk(
    'elegant Central London',
    'Marylebone',
    '£1,700 - £2,100',
    '£1,900/mo',
    ['Marylebone High Street', 'Baker Street', 'Regent\'s Park', 'Oxford Street side', 'Paddington side'],
    `Marylebone coliving offers refined Central London living — Marylebone High Street, Regent's Park and Baker Street connections. Private furnished rooms from £1,700/mo, no agency fees. Ideal for professionals who want a quiet, upscale neighbourhood with walkable access to the West End.`,
    ['Baker Street — 5 tube lines', 'Regent\'s Park next door', 'Upscale village atmosphere', '10 min walk to Oxford Street'],
    [
      { q: 'How much is coliving in Marylebone?', a: 'From £1,700/mo to £2,100/mo all-inclusive, no agency fees.' },
      { q: 'Is Marylebone good for professionals?', a: 'Yes — quiet, central, excellent transport via Baker Street and walking distance to the West End and City.' },
    ]
  ),
  'Battersea': uk(
    'riverside South West London',
    'Battersea',
    '£1,450 - £1,600',
    '£1,525/mo',
    ['Battersea Power Station', 'Nine Elms', 'Clapham Junction side', 'Battersea Park', 'Wandsworth'],
    `Battersea coliving combines riverside regeneration — including the iconic Power Station — with Northern line extension access. Private furnished rooms from £1,450/mo, no agency fees. Nine Elms and the South Bank are minutes away.`,
    ['Northern line extension at Battersea Power Station', 'Riverside walks and new retail', 'Battersea Park', 'Fast connections to the City'],
    [
      { q: 'How much is coliving in Battersea?', a: 'From £1,450/mo to £1,600/mo all-inclusive, no agency fees.' },
      { q: 'What is Battersea like now?', a: 'Transformed by the Power Station redevelopment — new shops, restaurants, cinema and Northern line access since 2021.' },
    ]
  ),
  'Harrow': uk(
    'leafy North West London suburb',
    'Harrow',
    '£1,200 - £1,500',
    '£1,350/mo',
    ['Harrow on the Hill', 'Harrow & Wealdstone', 'North Harrow', 'South Harrow', 'Pinner border'],
    `Harrow coliving offers suburban calm with Metropolitan line access to Baker Street in 20 minutes. Private furnished rooms from £1,200/mo, no agency fees. Home to Harrow School and a diverse international community.`,
    ['Metropolitan line to Baker Street in 20 min', 'From £1,200/mo — excellent value', 'Leafy suburban feel', 'Strong international community'],
    [
      { q: 'How much is coliving in Harrow?', a: 'From £1,200/mo to £1,500/mo all-inclusive, no agency fees.' },
      { q: 'How far is Harrow from central London?', a: 'Metropolitan line to Baker Street: 20 min. To Liverpool Street: 35 min.' },
    ]
  ),
  'Earlsfield': uk(
    'friendly South West London',
    'Earlsfield',
    '£1,300 - £1,550',
    '£1,425/mo',
    ['Earlsfield station', 'Garratt Lane', 'Summerstown', 'Wandsworth Common', 'Tooting border'],
    `Earlsfield coliving offers village-community feel in Zone 3 with South Western Railway to Waterloo in 15 minutes. Private furnished rooms from £1,300/mo, no agency fees. Popular with young professionals and families.`,
    ['15 min train to Waterloo', 'Village high street on Garratt Lane', 'Wandsworth Common nearby', 'From £1,300/mo — good SW London value'],
    [
      { q: 'How much is coliving in Earlsfield?', a: 'From £1,300/mo to £1,550/mo all-inclusive, no agency fees.' },
      { q: 'Is Earlsfield good for commuting?', a: 'South Western Railway to Waterloo in 15 min — one of the best SW London commutes.' },
    ]
  ),
  'Westbourne Park': uk(
    'trendy West London canal side',
    'Westbourne Park',
    '£1,550 - £1,750',
    '£1,650/mo',
    ['Westbourne Park station', 'Notting Hill border', 'Royal Oak', 'Little Venice side', 'Portobello side'],
    `Westbourne Park coliving sits between Notting Hill and Little Venice — canal walks, independent cafés and Circle/H&C line access. Private furnished rooms from £1,550/mo, no agency fees.`,
    ['Circle & Hammersmith & City lines', 'Canal-side walks to Little Venice', 'Between Notting Hill and Paddington', 'Creative West London community'],
    [
      { q: 'How much is coliving in Westbourne Park?', a: 'From £1,550/mo to £1,750/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Primrose Hill': uk(
    'village charm with skyline views',
    'Primrose Hill',
    '£1,700 - £2,000',
    '£1,850/mo',
    ['Primrose Hill park', 'Regent\'s Park Road', 'Chalk Farm', 'Camden border', 'Mornington Crescent'],
    `Primrose Hill coliving offers one of London's best views and a village atmosphere minutes from Camden and the West End. Private furnished rooms from £1,700/mo, no agency fees.`,
    ['Iconic park views over London', 'Village high street', 'Northern line at Chalk Farm', 'Steps from Regent\'s Park'],
    [
      { q: 'How much is coliving in Primrose Hill?', a: 'From £1,700/mo to £2,000/mo all-inclusive, no agency fees. Premium North London location.' },
    ]
  ),
  'Belsize Park': uk(
    'leafy North London between Hampstead and Camden',
    'Belsize Park',
    '£1,550 - £1,750',
    '£1,650/mo',
    ['Belsize Park', 'Hampstead border', 'Swiss Cottage', 'Chalk Farm', 'Gospel Oak'],
    `Belsize Park coliving combines Hampstead proximity with Northern line access and a relaxed residential feel. Private furnished rooms from £1,550/mo, no agency fees.`,
    ['Northern line at Belsize Park', 'Leafy residential streets', 'Near Hampstead Heath', 'Quiet alternative to Camden'],
    [
      { q: 'How much is coliving in Belsize Park?', a: 'From £1,550/mo to £1,750/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Clapham Common': uk(
    'popular South London green space hub',
    'Clapham Common',
    '£1,400 - £1,650',
    '£1,525/mo',
    ['Clapham Common park', 'Clapham South', 'Clapham Old Town', 'Abbeville Village', 'Northside'],
    `Clapham Common coliving surrounds one of London's largest parks with Northern line access to the West End in 15 minutes. Private furnished rooms from £1,400/mo, no agency fees. Vibrant bars, restaurants and a strong young professional community.`,
    ['Northern line to Leicester Square in 15 min', 'Large park on your doorstep', 'Vibrant nightlife and dining', 'Popular with young professionals'],
    [
      { q: 'How much is coliving near Clapham Common?', a: 'From £1,400/mo to £1,650/mo all-inclusive, no agency fees.' },
      { q: 'Is Clapham Common good for social life?', a: 'Yes — one of South London\'s most popular areas for bars, restaurants and the common itself.' },
    ]
  ),
  'Finsbury Park': uk(
    'vibrant North London transport hub',
    'Finsbury Park',
    '£1,415 - £1,550',
    '£1,480/mo',
    ['Finsbury Park station', 'Stroud Green', 'Manor House', 'Harringay', 'Seven Sisters border'],
    `Finsbury Park coliving offers Victoria, Piccadilly and Overground connections — one of North London's best-connected hubs. Private furnished rooms from £1,415/mo, no agency fees. Diverse community, great food scene and the park itself.`,
    ['Victoria + Piccadilly + Overground', 'Large park and events venue', 'Diverse, vibrant community', 'From £1,415/mo — North London value'],
    [
      { q: 'How much is coliving in Finsbury Park?', a: 'From £1,415/mo to £1,550/mo all-inclusive, no agency fees.' },
      { q: 'How well connected is Finsbury Park?', a: 'Victoria line to Oxford Circus in 15 min. Piccadilly to King\'s Cross in 5 min. Overground across East London.' },
    ]
  ),
  'Maida Vale': uk(
    'elegant canal-side West London',
    'Maida Vale',
    '£1,500 - £1,700',
    '£1,600/mo',
    ['Maida Vale', 'Little Venice', 'Warwick Avenue', 'St John\'s Wood border', 'Paddington Recreation Ground'],
    `Maida Vale coliving offers elegant tree-lined streets and Little Venice canal walks with Bakerloo line access. Private furnished rooms from £1,500/mo, no agency fees. Quiet, upscale West London living.`,
    ['Little Venice canal walks', 'Bakerloo line connections', 'Quiet, upscale neighbourhood', 'Near Paddington and St John\'s Wood'],
    [
      { q: 'How much is coliving in Maida Vale?', a: 'From £1,500/mo to £1,700/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Tooting': uk(
    'diverse and affordable South London',
    'Tooting',
    '£1,200 - £1,450',
    '£1,325/mo',
    ['Tooting Broadway', 'Tooting Bec', 'Tooting Common', 'Balham border', 'Colliers Wood'],
    `Tooting coliving combines excellent value with Northern line access to the West End in 20 minutes and one of London's best food markets. Private furnished rooms from £1,200/mo, no agency fees.`,
    ['Northern line to Leicester Square in 20 min', 'From £1,200/mo — strong South London value', 'Famous Broadway market', 'Tooting Common park'],
    [
      { q: 'How much is coliving in Tooting?', a: 'From £1,200/mo to £1,450/mo all-inclusive, no agency fees. Excellent value for Zone 3.' },
    ]
  ),
  'West Kensington': uk(
    'convenient West London Zone 2',
    'West Kensington',
    '£1,450 - £1,650',
    '£1,550/mo',
    ['West Kensington', 'Barons Court', 'Brook Green', 'Olympia', 'Earl\'s Court border'],
    `West Kensington coliving offers District line access to the West End and City with quieter residential streets than Earl's Court. Private furnished rooms from £1,450/mo, no agency fees.`,
    ['District line to Victoria in 12 min', 'Quieter than Earl\'s Court', 'Brook Green and Olympia nearby', 'Zone 2 West London'],
    [
      { q: 'How much is coliving in West Kensington?', a: 'From £1,450/mo to £1,650/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Limehouse': uk(
    'historic East London docklands',
    'Limehouse',
    '£1,580 - £2,120',
    '£1,800/mo',
    ['Limehouse DLR', 'Limehouse Basin', 'Stepney Green border', 'Canary Wharf side', 'Wapping border'],
    `Limehouse coliving combines historic docklands character with DLR to Canary Wharf in 5 minutes. Private furnished rooms from £1,580/mo, no agency fees. Node Living and other operators offer premium East London coliving here.`,
    ['DLR to Canary Wharf in 5 min', 'Historic canal basin', 'Zone 2 East London', 'Premium coliving from Node Living'],
    [
      { q: 'How much is coliving in Limehouse?', a: 'From £1,580/mo to £2,120/mo all-inclusive, no agency fees.' },
      { q: 'Is Limehouse good for Canary Wharf workers?', a: 'Excellent — DLR to Canary Wharf in 5 minutes. Also DLR to Bank in 15 min.' },
    ]
  ),
  'Hammersmith': uk(
    'major West London transport hub',
    'Hammersmith',
    '£1,500 - £1,800',
    '£1,650/mo',
    ['Hammersmith Broadway', 'Ravenscourt Park', 'Fulham border', 'Shepherd\'s Bush border', 'Stamford Brook'],
    `Hammersmith coliving sits at a major interchange — Piccadilly, District, Circle and Hammersmith & City lines plus excellent bus links. Private furnished rooms from £1,500/mo, no agency fees. Scape and other operators have student and young professional coliving here.`,
    ['4 tube lines at Hammersmith', 'Riverside Thames Path', 'Westfield Shepherd\'s Bush nearby', 'Strong transport hub'],
    [
      { q: 'How much is coliving in Hammersmith?', a: 'From £1,500/mo to £1,800/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Mile End': uk(
    'East London student and creative hub',
    'Mile End',
    '£1,400 - £1,650',
    '£1,525/mo',
    ['Mile End station', 'Bow Common', 'Stepney Green border', 'Victoria Park side', 'QMUL campus'],
    `Mile End coliving offers Central, District and Hammersmith & City line access with Queen Mary University and Victoria Park nearby. Private furnished rooms from £1,400/mo, no agency fees. Scape operates purpose-built coliving in this area.`,
    ['Central + District + H&C lines', 'Queen Mary University campus', 'Victoria Park 5 min walk', 'Creative East London community'],
    [
      { q: 'How much is coliving in Mile End?', a: 'From £1,400/mo to £1,650/mo all-inclusive, no agency fees.' },
      { q: 'Is Mile End good for students?', a: 'Yes — Queen Mary University is on the doorstep. Scape Mile End offers purpose-built student and young professional coliving.' },
    ]
  ),
  'Canada Water': uk(
    'regenerated East London Jubilee hub',
    'Canada Water',
    '£1,500 - £1,750',
    '£1,625/mo',
    ['Canada Water station', 'Surrey Quays', 'Rotherhithe', 'Scape building', 'Southwark Park'],
    `Canada Water coliving offers Jubilee line to Canary Wharf in 2 minutes and London Bridge in 5 minutes. Private furnished rooms from £1,500/mo, no agency fees. Scape Canada Water is a major coliving building in this regenerated docklands area.`,
    ['Jubilee line to Canary Wharf in 2 min', 'Scape Canada Water coliving', 'Regenerated docklands', 'Fast access to City and South Bank'],
    [
      { q: 'How much is coliving in Canada Water?', a: 'From £1,500/mo to £1,750/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Kings Cross': uk(
    'London\'s best-connected transport hub',
    'Kings Cross',
    '£1,600 - £2,000',
    '£1,800/mo',
    ['King\'s Cross St Pancras', 'Granary Square', 'Coal Drops Yard', 'Bloomsbury border', 'Camden border'],
    `Kings Cross coliving puts you at London's most connected station — 6 tube lines, Thameslink, Eurostar and the Elizabeth line. Private furnished rooms from £1,600/mo, no agency fees. Google HQ, Central Saint Martins and the Knowledge Quarter are all here.`,
    ['6 tube lines + Eurostar + Elizabeth line', 'Google HQ and tech hub', 'Granary Square and Coal Drops Yard', 'UCL and Central Saint Martins nearby'],
    [
      { q: 'How much is coliving in Kings Cross?', a: 'From £1,600/mo to £2,000/mo all-inclusive, no agency fees.' },
      { q: 'Why is Kings Cross popular for coliving?', a: 'Best transport hub in London, major tech and creative employers, and extensive regeneration with restaurants, shops and public spaces.' },
    ]
  ),
  'Clapham Junction': uk(
    'Britain\'s busiest railway hub',
    'Clapham Junction',
    '£1,400 - £1,650',
    '£1,525/mo',
    ['Clapham Junction station', 'Northcote Road', 'Battersea Rise', 'Lavender Hill', 'Wandsworth Common'],
    `Clapham Junction coliving offers the UK's busiest interchange — fast trains to Victoria (5 min), Waterloo (7 min) and across South London. Private furnished rooms from £1,400/mo, no agency fees. Lyvly operates coliving houses in this area.`,
    ['Fastest South London rail hub', 'Northcote Road shops and cafés', '5 min train to Victoria', 'Lyvly coliving houses nearby'],
    [
      { q: 'How much is coliving in Clapham Junction?', a: 'From £1,400/mo to £1,650/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Stockwell': uk(
    'affordable Zone 2 South London',
    'Stockwell',
    '£1,350 - £1,550',
    '£1,450/mo',
    ['Stockwell station', 'Brixton border', 'Clapham North', 'Oval', 'Vauxhall border'],
    `Stockwell coliving offers Northern and Victoria line access at below-average Zone 2 prices. Private furnished rooms from £1,350/mo, no agency fees. Lyvly coliving houses and good connections to the City and West End.`,
    ['Northern + Victoria lines', 'From £1,350/mo — Zone 2 value', 'Between Brixton and Clapham', 'Lyvly coliving in area'],
    [
      { q: 'How much is coliving in Stockwell?', a: 'From £1,350/mo to £1,550/mo all-inclusive, no agency fees.' },
    ]
  ),
  'East Putney': uk(
    'leafy South West London',
    'East Putney',
    '£1,400 - £1,600',
    '£1,500/mo',
    ['East Putney station', 'Putney Heath', 'Wandsworth border', 'Southfields border', 'Putney Bridge'],
    `East Putney coliving combines District line access with Putney Heath and the Thames nearby. Private furnished rooms from £1,400/mo, no agency fees. Quieter than Clapham with excellent SW London amenities.`,
    ['District line to Westminster in 15 min', 'Putney Heath and Thames nearby', 'Leafy SW London', 'Lyvly coliving houses'],
    [
      { q: 'How much is coliving in East Putney?', a: 'From £1,400/mo to £1,600/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Fulham': uk(
    'upmarket South West London',
    'Fulham',
    '£1,500 - £1,800',
    '£1,650/mo',
    ['Fulham Broadway', 'Parsons Green', 'Putney Bridge', 'Chelsea border', 'Imperial Wharf'],
    `Fulham coliving offers District line access and a village feel between Chelsea and Putney. Private furnished rooms from £1,500/mo, no agency fees. Popular with young professionals who want SW London quality of life.`,
    ['District line connections', 'Parsons Green and Fulham Broadway', 'Thames Path nearby', 'Upscale SW London living'],
    [
      { q: 'How much is coliving in Fulham?', a: 'From £1,500/mo to £1,800/mo all-inclusive, no agency fees.' },
    ]
  ),
  'New Malden': uk(
    'suburban South West London value',
    'New Malden',
    '£1,100 - £1,350',
    '£1,225/mo',
    ['New Malden station', 'Malden centre', 'Raynes Park border', 'Worcester Park', 'Motspur Park'],
    `New Malden coliving offers some of the best value in Greater London with South Western Railway to Waterloo in 25 minutes. Private furnished rooms from £1,100/mo, no agency fees. Known for its Korean community and excellent restaurants.`,
    ['From £1,100/mo — outer London value', '25 min train to Waterloo', 'Excellent Korean food scene', 'Suburban calm with city access'],
    [
      { q: 'How much is coliving in New Malden?', a: 'From £1,100/mo to £1,350/mo all-inclusive, no agency fees. Among London\'s most affordable coliving options.' },
    ]
  ),
  'Hackney': uk(
    'creative East London hub',
    'Hackney',
    '£1,400 - £1,800',
    '£1,600/mo',
    ['Hackney Central', 'London Fields', 'Dalston', 'Hoxton border', 'Victoria Park'],
    `Hackney coliving puts you in East London's creative heartland — London Fields, Broadway Market and Overground connections across the city. Private furnished rooms from £1,400/mo, no agency fees. Popular with designers, developers and startup founders.`,
    ['Overground across East and North London', 'London Fields and Broadway Market', 'Creative and startup community', 'Victoria Park on the doorstep'],
    [
      { q: 'How much is coliving in Hackney?', a: 'From £1,400/mo to £1,800/mo all-inclusive, no agency fees.' },
      { q: 'Is Hackney good for creatives?', a: 'Yes — one of London\'s most creative neighbourhoods with studios, galleries, markets and a strong tech/startup scene.' },
    ]
  ),
  'Clapham': uk(
    'South London\'s most popular neighbourhood',
    'Clapham',
    '£1,450 - £1,700',
    '£1,575/mo',
    ['Clapham High Street', 'Clapham Old Town', 'Abbeville Village', 'North Clapham', 'Clapham South'],
    `Clapham coliving offers Northern line access, vibrant nightlife and Clapham Common — one of South London's most sought-after areas. Private furnished rooms from £1,450/mo, no agency fees.`,
    ['Northern line to the West End in 15 min', 'Clapham Common park', 'Vibrant high street and nightlife', 'Popular with young professionals'],
    [
      { q: 'How much is coliving in Clapham?', a: 'From £1,450/mo to £1,700/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Poplar': uk(
    'East London docklands value',
    'Poplar',
    '£1,500 - £1,900',
    '£1,700/mo',
    ['Poplar DLR', 'Canary Wharf side', 'Limehouse Cut', 'Blackwall', 'All Saints'],
    `Poplar coliving offers DLR access to Canary Wharf in minutes at below-Canary-Wharf prices. Private furnished rooms from £1,500/mo, no agency fees. Fizzy Living operates premium coliving buildings in this area.`,
    ['DLR to Canary Wharf in 5 min', 'Fizzy Living coliving spaces', 'East London regeneration', 'Below Canary Wharf prices'],
    [
      { q: 'How much is coliving in Poplar?', a: 'From £1,500/mo to £1,900/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Stepney Green': uk(
    'affordable East London',
    'Stepney Green',
    '£1,400 - £1,650',
    '£1,525/mo',
    ['Stepney Green station', 'Mile End border', 'Whitechapel border', 'Limehouse Cut', 'Arbour Square'],
    `Stepney Green coliving offers District and Hammersmith & City line access in Zone 2 East London. Private furnished rooms from £1,400/mo, no agency fees. Fizzy Living coliving and fast access to the City.`,
    ['District + H&C lines to the City', 'Zone 2 East London value', 'Fizzy Living in area', 'Near Whitechapel and Mile End'],
    [
      { q: 'How much is coliving in Stepney Green?', a: 'From £1,400/mo to £1,650/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Hayes': uk(
    'Outer West London with Elizabeth line',
    'Hayes',
    '£1,100 - £1,350',
    '£1,225/mo',
    ['Hayes & Harlington', 'Botwell', 'Yeading border', 'Heathrow proximity', 'Stockley Park'],
    `Hayes coliving offers Elizabeth line access to Paddington in 20 minutes and proximity to Heathrow. Private furnished rooms from £1,100/mo, no agency fees. Fizzy Living operates coliving here — excellent value for outer London.`,
    ['Elizabeth line to Paddington in 20 min', 'From £1,100/mo — outer London value', 'Heathrow proximity', 'Fizzy Living coliving'],
    [
      { q: 'How much is coliving in Hayes?', a: 'From £1,100/mo to £1,350/mo all-inclusive, no agency fees.' },
    ]
  ),
  'Epsom': uk(
    'Surrey town with fast London access',
    'Epsom',
    '£1,100 - £1,300',
    '£1,200/mo',
    ['Epsom town centre', 'Epsom Downs', 'Ewell', 'Stoneleigh', 'Tattenham Corner'],
    `Epsom coliving offers the best of Surrey town living with South Western Railway to Waterloo in 35 minutes. Private furnished rooms from £1,100/mo, no agency fees. Fizzy Living and maximum space for your budget.`,
    ['From £1,100/mo — lowest Greater London area prices', '35 min train to Waterloo', 'Surrey town with green spaces', 'Fizzy Living coliving'],
    [
      { q: 'How much is coliving in Epsom?', a: 'From £1,100/mo to £1,300/mo all-inclusive, no agency fees. Among the most affordable options in the Coolliving London inventory.' },
    ]
  ),
  'Islington': uk(
    'vibrant North London with great tube links',
    'Islington',
    '£1,446 - £1,663',
    '£1,550/mo',
    ['Upper Street', 'Angel', 'Highbury', 'Caledonian Road', 'Essex Road'],
    `Islington coliving offers Piccadilly line access, Upper Street's restaurants and bars, and proximity to King's Cross and the City. Private furnished rooms from £1,446/mo, no agency fees. Chapter Living operates purpose-built coliving in Islington and Highbury.`,
    ['Piccadilly line at Angel and Caledonian Road', 'Upper Street dining and nightlife', 'Chapter Living coliving', 'Near UAL Central Saint Martins'],
    [
      { q: 'How much is coliving in Islington?', a: 'From £1,446/mo to £1,663/mo all-inclusive, no agency fees. Chapter Living from £1,446/mo.' },
      { q: 'Is Islington good for students?', a: 'Yes — close to UAL Central Saint Martins, City University and UCL. Chapter Living offers student-focused coliving with gym and study spaces.' },
    ],
    true
  ),
  'White City': uk(
    'West London next to Westfield and the BBC',
    'White City',
    '£1,684 - £1,900',
    '£1,684/mo',
    ['White City', 'Wood Lane', 'Shepherd\'s Bush', 'Television Centre', 'Imperial West'],
    `White City coliving sits next to Westfield shopping, BBC Television Centre and Imperial College's White City campus. Private furnished rooms from £1,684/mo, no agency fees. Chapter Living operates design-led coliving here.`,
    ['Central line at White City and Wood Lane', 'Westfield London on doorstep', 'Imperial College campus', 'Chapter Living design-led spaces'],
    [
      { q: 'How much is coliving in White City?', a: 'From £1,684/mo all-inclusive, no agency fees. Chapter Living from £1,684/mo.' },
    ],
    true
  ),
  'London Bridge': uk(
    'premium central London near Borough Market',
    'London Bridge',
    '£1,820 - £2,100',
    '£1,820/mo',
    ['London Bridge station', 'Borough Market', 'Southwark Cathedral', 'The Shard area', 'Bankside'],
    `London Bridge coliving places you steps from Borough Market, Tate Modern and the Jubilee and Northern lines. Private furnished rooms from £1,820/mo, no agency fees. Chapter Living operates premium coliving in this iconic central location.`,
    ['Jubilee + Northern lines', 'Borough Market on doorstep', 'Tate Modern and South Bank walks', 'Chapter Living premium spaces'],
    [
      { q: 'How much is coliving in London Bridge?', a: 'From £1,820/mo all-inclusive, no agency fees.' },
    ],
    true
  ),
  'Westminster': uk(
    'iconic Central London by the Thames',
    'Westminster',
    '£2,102 - £2,400',
    '£2,102/mo',
    ['Westminster Abbey', 'Victoria', 'Pimlico', 'Lambeth Bridge', 'Millbank'],
    `Westminster coliving offers iconic Central London living — Parliament, the Thames and Victoria station connections. Private furnished rooms from £2,102/mo, no agency fees. Chapter Living operates premium coliving near Lambeth and Waterloo.`,
    ['Victoria and Westminster stations', 'Thames and South Bank walks', 'Iconic Central London location', 'Chapter Living premium coliving'],
    [
      { q: 'How much is coliving in Westminster?', a: 'From £2,102/mo all-inclusive, no agency fees. Premium Central London pricing.' },
    ],
    true
  ),
  'South Bank': uk(
    'vibrant cultural hub by the Thames',
    'South Bank',
    '£2,080 - £2,300',
    '£2,080/mo',
    ['Southwark', 'Waterloo', 'Bankside', 'Tate Modern', 'Borough'],
    `South Bank coliving puts you in London's cultural heartland — Tate Modern, Shakespeare's Globe, the National Theatre and the Thames Path. Private furnished rooms from £2,080/mo, no agency fees.`,
    ['Jubilee line at Waterloo and Southwark', 'Tate Modern and Globe Theatre', 'Thames Path walks', 'Chapter Living nearby'],
    [
      { q: 'How much is coliving on the South Bank?', a: 'From £2,080/mo all-inclusive, no agency fees.' },
    ],
    true
  ),
  'Portobello': uk(
    'characterful West London near Notting Hill',
    'Portobello',
    '£1,036 - £1,400',
    '£1,200/mo',
    ['Portobello Road', 'Ladbroke Grove', 'Notting Hill Gate', 'Westbourne Park', 'North Kensington'],
    `Portobello coliving offers the famous market street and Notting Hill proximity at competitive prices. Private furnished rooms from £1,036/mo, no agency fees. Chapter Living operates affordable coliving in this characterful West London area.`,
    ['Portobello Road Market', 'From £1,036/mo — West London value', 'Circle & Hammersmith & City lines', 'Chapter Living from £1,036/mo'],
    [
      { q: 'How much is coliving in Portobello?', a: 'From £1,036/mo all-inclusive, no agency fees — among the most affordable Central/West London coliving options.' },
    ],
    true
  ),
  'Ealing': uk(
    'leafy West London on Elizabeth line',
    'Ealing',
    '£1,187 - £1,450',
    '£1,300/mo',
    ['Ealing Broadway', 'Ealing Common', 'Acton border', 'West Ealing', 'Hanwell'],
    `Ealing coliving offers Elizabeth line access to Paddington in 12 minutes and a genuine town-centre feel. Private furnished rooms from £1,187/mo, no agency fees. Popular with Brunel, UWL and Ealing students and young professionals.`,
    ['Elizabeth line to Paddington in 12 min', 'From £1,187/mo — West London value', 'Leafy town-centre feel', 'Chapter Living from £1,187/mo'],
    [
      { q: 'How much is coliving in Ealing?', a: 'From £1,187/mo all-inclusive, no agency fees.' },
    ],
    true
  ),
  'Kingston': uk(
    'thriving South West London riverside town',
    'Kingston',
    '£1,000 - £1,400',
    '£1,200/mo',
    ['Kingston town centre', 'Kingston University', 'Hampton Court border', 'New Malden border', 'Surbiton'],
    `Kingston coliving offers riverside market-town living with Kingston University and fast trains to Waterloo in 32 minutes. Private furnished rooms from £1,000/mo, no agency fees. aparto operates student and young professional coliving here.`,
    ['From £1,000/mo — among London\'s best value', '32 min train to Waterloo', 'Kingston University campus', 'aparto coliving spaces'],
    [
      { q: 'How much is coliving in Kingston?', a: 'From £1,000/mo to £1,400/mo all-inclusive, no agency fees.' },
      { q: 'Is Kingston good for students?', a: 'Yes — Kingston University is in the town centre. aparto offers purpose-built coliving with study spaces and community events.' },
    ],
    true
  ),
};
